import { render, staticRenderFns } from "./MenuOption.html?vue&type=template&id=ff1ff976&external"
import script from "./MenuOption.vue?vue&type=script&lang=js"
export * from "./MenuOption.vue?vue&type=script&lang=js"
import style0 from "./MenuOption.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports